<kendo-window *ngIf="isOpened && !modal" #kendoWindow
              [minWidth]="minWidth" [(width)]="width" [minHeight]="minHeight" [(height)]="height"
              [resizable]="isResizable" [draggable]="isDraggable"
              [(top)]="top" [(left)]="left" [(right)]="right"
              (close)="close()" (stateChange)="stateChangeEvent($event)">
    <kendo-window-titlebar>
        <div class="k-window-title" (dblclick)="preventEvent($event, !isMaximizable)">{{ windowTitle }}</div>
        <slot name="actions"></slot>
        <button kendoWindowMaximizeAction title="Maximize" *ngIf="isMaximizable"></button>
        <button kendoWindowRestoreAction title="Restore" *ngIf="isMaximizable"></button>
        <button kendoWindowCloseAction title="Close"></button>
    </kendo-window-titlebar>

    <slot name="content"></slot>
</kendo-window>

<kendo-dialog *ngIf="isOpened && modal" #kendoDialog [ngClass]="{ 'hideClose': !closable }"
              [minWidth]="minWidth" [(width)]="width" [(height)]="height"
              (close)="close()">
    <kendo-dialog-titlebar>
        <div class="k-window-title">{{ windowTitle }}</div>
        <slot name="actions"></slot>
    </kendo-dialog-titlebar>
    <slot name="content"></slot>
</kendo-dialog>
